import { createSlideVisibilityTracking } from 'common/hooks/useSlideVisibilityTracking';
import { logViewAd, logSwiperSlideView, PromotionSources } from 'config/analytics';
import { CarouselBannerItem } from './useAdCarousel';

export const useSlideVisibilityTracking = createSlideVisibilityTracking<CarouselBannerItem>({
    getBannerId: (banner) => banner.id,
    getBannerTitle: (banner) => banner.title || banner.id,
    logViewAd: (params) => {
        logViewAd({
            ...params,
            source: PromotionSources.Contentful,
        });
    },
    logSlideView: logSwiperSlideView,
    swiperName: 'P1 Hero',
});
